export default {
  name: 'Scripts',
  fields: {
    extensionPoint: 'Extension point',
    data: 'Script',
    description: 'Description',
    updated: 'Updated',
    message: 'Changelog message',
    edit: 'Edit',
    editScript: 'Edit script',
    searchInProgress: 'Search in progress\u2026',
    noResultsFound: 'No results found',
    updatedAt: 'Updated at',
    scriptPlaceholder: 'Write your script here',
    script: 'Script',
  },
};
